import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import {formValueSelector} from "redux-form/immutable";
import {withRouter} from "react-router";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../customers/forms/ShippingAddressForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelCreateShippingOrder} from "../../actions/ShippingApiActions";
import {fromJS, List} from "immutable";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";
import {getUSStates, getCanadaProvinces, isUS, isCanada} from "../../lib/CountriesAndStates";
import {hasStateProvince} from "../../lib/AddressRules";
import {validateShippingAddress} from "../../lib/AddressValidation";

function validateForm(values, props) {
  return validateShippingAddress(values).toJS();
}

class CreateOrderFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.createShippingOrder(values.toJS())
      .then((response) => {
        if (response.data.createShippingOrder.errors.length <= 0) {
          this.props.cancelCreateShippingOrder();
          this.props.router.push(`/shipping/orders/${response.data.createShippingOrder.orderId}`);
        } else {
          let errors = createValidationErrors(response.data.createShippingOrder.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelCreateShippingOrder();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let countries = fromJS(data.countriesInShops);
    let stateProvinces = List([]);
    if (this.props.showUSStates) stateProvinces = getUSStates();
    if (this.props.showCanadaProvinces) stateProvinces = getCanadaProvinces();

    return (
      <Form
        errors={this.state.errors}
        validate={validateForm}
        countries={countries}
        stateProvinces={stateProvinces}
        showAttentionName={true}
        showStateProvince={this.props.showStateProvince}
        showPhoneNr={true}
        showEmail={true}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const CREATE_SHIPPING_ORDER = gql`
  mutation createShippingOrder($data: CreateShippingOrderInput!) {
    createShippingOrder(input: $data) {
      orderId
      errors { key message }
    }
  }
`;

const GET_COUNTRIES = gql`
  query countriesInShops {
    countriesInShops {
      code
      name
    }
  }
`;

const withAddressQuery = compose(
  graphql(GET_COUNTRIES, {
    options: (props) => ({
      fetchPolicy: "network-only"
    })
  }),
  graphql(CREATE_SHIPPING_ORDER, {
    props: ({ mutate }) => ({
      createShippingOrder: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

const CreateOrderFormContainerWithData = withAddressQuery(CreateOrderFormContainer);

const selector = formValueSelector("ShippingAddressForm");
function mapStateToProps(state, ownProps) {
  return {
    showUSStates: isUS(selector(state, "addressCountryCode")),
    showCanadaProvinces: isCanada(selector(state, "addressCountryCode")),
    showStateProvince: hasStateProvince(selector(state, "addressCountryCode"))
  }
}

export default connect(mapStateToProps, {cancelCreateShippingOrder})(withRouter(CreateOrderFormContainerWithData));